import React from 'react';

import TableSection from './section';

export default class TableBody extends React.Component {
  render() {
    return (
      <TableSection
        {...this.props}
        section="bodyRows"
      />
    );
  }
}
